<template>
    <div class="container">
        <div class="header">
            <div class="back" @click="back">
                <van-icon name="arrow-left" />
                <span>返回</span>
            </div>
            <span>绑定医生</span>
        </div>
        <div class="bind_tip">* 将该微信用户绑定至某位医生后，其所属的所有患者线上问诊时，均会匹配给该医生。</div>
        <div class="bind_content" v-watermark>
            <div class="bind_content_header">
                <div class="bind_content_header_item">医生</div>
                <div class="bind_content_header_item">状态</div>
                <div class="bind_content_header_item">已绑定用户数</div>
            </div>
            <div class="bind_content_list">
                <div class="bind_content_item" v-for="item in list" :key="item.doctorNo" @click="bindDoctor(item)">
                    <div class="bind_content_item_doctor">
                        <img :src="item.photo" alt="">
                        <span>{{item.name}}</span>
                    </div>
                    <div class="bind_content_item_status" :class="{'bind_content_item_status0': item.isOnline === 0}">{{item.doctorStatusName}}</div>
                    <div class="bind_content_item_num">
                        <span>{{item.boundUsersNum}}</span>
                        <van-icon name="arrow" />
                    </div>
                </div>
            </div>
        </div>
        <pagination :total="total" :pageSize="searchData.pageSize" @pageChange="pageChange"></pagination>
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { getEnterpriseWechatlist, userBindingDoctor } from '../../api/home.js'
export default {
    data() {
        return {
            total: 0,
            searchData: {
                pageSize: 10,
                pageNum: 1,
                doctorStatus: 0
            },
            list: [],
            item: {}
        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            getEnterpriseWechatlist(this.searchData).then(res => {
                if(res.code == 0){
                    this.list = res.data.list
                    this.total = res.data.total
                }
            })
        },
        pageChange(pageNo) {
            this.searchData.pageNum = pageNo
            this.getList()
        },
        // 返回
        back() {
            this.$router.back()
        },
        bindDoctor(row) {
            let userNos = JSON.parse(sessionStorage.getItem('userNos'))
            let content = `确定将${userNos.length}位用户绑定至${row.name}医生？<span style="color: #ee0a24">如有进行中的问诊，将会一同转移给换绑后的医生。</span>`
            if(this.$route.query.nickName){
                content = `确定将该用户绑定至${row.name}医生？<span style="color: #ee0a24">如有进行中的问诊，将会一同转移给换绑后的医生。</span>`
            }
            Dialog.confirm({
                title: '提示',
                message: content,
                allowHtml: true
            })
            .then(() => {
                // on confirm
                let data = {
                    userNos,
                    doctorNo: row.doctorNo
                }
                this.userBindingDoctor(data)
            })
            .catch(() => {
                // on cancel
            });
        },

        userBindingDoctor(data) {
            userBindingDoctor(data).then(res => {
                if(res.code == 0){
                    this.$toast.success('绑定医生成功')
                    setTimeout(() => {
                        this.$router.back()
                    }, 1500);
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .container {
        padding: 10px;
        .header {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            font-weight: bold;
            color: #333333;
            position: relative;
            font-size: 16px;
            margin: -10px -10px 0 -10px;
            .back {
                display: flex;
                align-items: center;
                position: absolute;
                left: 10px;
                font-weight: 500;
                color: #666666;
                font-size: 14px;
                cursor: pointer;
            }
        }
        .bind_tip {
            width: 100%;
            background: #FFFFFF;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            color: #E81C1C;
            padding: 9px;
            box-sizing: border-box;
            height: 58px;
            box-sizing: border-box;
            margin-top: 10px;
        }
        .bind_content {
            width: 100%;
            background: #FFFFFF;
            border-radius: 4px;
            padding: 16px;
            box-sizing: border-box;
            margin-top: 10px;
            height: calc(100vh - #{'240px'});
             overflow-y: scroll;
            .bind_content_header {
                width: 100%;
                height: 44px;
                background: #F6FBFF;
                display: flex;
                align-items: center;
                padding: 0 12px;
                box-sizing: border-box;
                .bind_content_header_item {
                    width: 33.33%;
                    color: #333333;
                    font-size: 14px;
                }
            }
            .bind_content_list {
                font-size: 14px;
                color: #333333;
                .bind_content_item {
                    width: 100%;
                    height: 44px;
                    display: flex;
                    align-items: center;
                    // background: #fff;
                    padding: 0 12px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #F6FBFF;
                    cursor: pointer;
                    & > div {
                        width: 33.33%;
                    }
                    .bind_content_item_doctor {
                        display: flex;
                        align-items: center;
                        img {
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            margin-right: 8px;
                        }
                    }
                    .bind_content_item_status {
                        color: #0FBC54;
                    }
                    .bind_content_item_status0 {
                        color: #999999;
                    }
                    .bind_content_item_num {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                }
            }
        }
    }
</style>